import { createContext } from 'react';

export const ReturnUrlContext = createContext<string | null>(null);
